import React, { useState, useEffect, useRef } from "react";
import HeroSection from "../components/home/HeroSection";
import StickySection from "../components/home/StickySection";
import WorkSection from "../components/home/WorkSection";
import AwardsSection from "../components/home/AwardsSection";
import CTASection from "../components/home/CTASection";

export default function Home() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const sections = [
    { id: "hero", type: "top" },
    {
      id: "sticky-section",
      type: "sticky-pause",
      stickyId: "sticky-section",
      progress: 0,
    },
    {
      id: "sticky-section",
      type: "sticky-pause",
      stickyId: "sticky-section",
      progress: 0.5,
    },
    { id: "work-section-header", type: "element" },
    { id: "work-project-2", type: "element" },
    { id: "work-project-3", type: "element" },
    { id: "awards", type: "no-offset" },
    { id: "cta", type: "element" },
  ];

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://unpkg.com/lenis@1.1.19/dist/lenis.min.js";
    script.onload = () => {
      const lenis = new window.Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smooth: true,
      });

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
    };
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <HeroSection />
      <StickySection />
      <WorkSection />
      <AwardsSection />
      <CTASection />
    </>
  );
}
